import { useContext } from 'react';

import { AdminProctorDetailsContext } from './admin-proctor-details-provider';

function useAdminProctorDetails() {
  const context = useContext(AdminProctorDetailsContext);

  if (!context) {
    throw new Error('useAdminProctorDetails must be used within a AdminProctorDetailsProvider');
  }

  return context;
}

export { useAdminProctorDetails };
